/**
 * Main Controller File for Feed Page
 */

import { useAppDispatch, useAppSelector } from "@/hooks/reduxHooks";
import { RootState } from "@/redux/store";
import { useEffect, useState } from "react";
import { GetFeedInterface } from "@/interfaces/services/feed";

import Feed from "@/redux/slices/thunk/feed";
import FeedPresentation from "../presentation/feed.presentation";

const FeedController = () => {
  const dispatch = useAppDispatch();

  const feedError = (state: RootState) => state.feed.isError;
  const isSuccess = (state: RootState) => state.feed.isSuccessful;
  const feedLoading = (state: RootState) => state.feed.isLoading;
  const message = (state: RootState) => state.feed.message;
  const feedData = (state: RootState) => state.feed.feed;

  const isError = useAppSelector(feedError);
  const success = useAppSelector(isSuccess);
  const isLoading = useAppSelector(feedLoading);
  const feed = useAppSelector(feedData);
  const msg = useAppSelector(message);

  useEffect(() => {
    let data: GetFeedInterface = {
      session: "sessionID",
    };

    dispatch(Feed.getFeedThunk(data));
  }, []);

  useEffect(() => {}, [feed]);

  return <FeedPresentation feed={feed} />;
};

export default FeedController;
